import styled from "styled-components"

export const StakeInputWrapper = styled.section`
  text-align: center;
  margin-bottom: 25.33px;
  animation: appear 0.333s linear forwards;
  @keyframes appear {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`

export const StakeCurrencyWrapper = styled.section`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
  margin: 0 10px;
  line-height: 18px;
  overflow: hidden;
  .amount {
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 14px;
  }
  .currency {
    display: flex;
    align-items: center;
    margin-right: 2px;
    height: 16px;
    font-size: 14px;
  }
`
